export default {
  "content": "<path fill=\"#BBB\" fill-rule=\"evenodd\" d=\"M29.617 17.75l9.68.84c1.76.14 2.46 2.34 1.12 3.5l-7.34 6.36 2.2 9.46c.4 1.72-1.46 3.08-2.98 2.16l-8.3-5.02-8.3 5c-1.52.92-3.38-.44-2.98-2.16l2.2-9.44-7.34-6.36c-1.34-1.16-.62-3.36 1.14-3.5l9.66-.82 3.78-8.92c.68-1.62 3-1.62 3.68 0l3.78 8.9zm-13.14 18.1l7.52-4.54 7.54 4.56-2-8.56 6.64-5.76-8.76-.76-3.42-8.08-3.4 8.06-8.76.76 6.64 5.76-2 8.56z\" clip-rule=\"evenodd\"/><path fill=\"transparent\" d=\"M24 35.04l8.3 5.02c1.52.92 3.38-.44 2.98-2.16l-2.2-9.44 7.34-6.36c1.34-1.16.62-3.36-1.14-3.5l-9.66-.82-3.78-8.92c-.68-1.62-3-1.62-3.68 0l-3.78 8.9-9.66.82c-1.76.14-2.48 2.34-1.14 3.5l7.34 6.36-2.2 9.44c-.4 1.72 1.46 3.08 2.98 2.16l8.3-5z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48",
    "fill": "none",
    "viewBox": "0 0 48 48"
  }
};